"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _components = require("../../../components");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MonthSelector = function MonthSelector(_ref) {
  var _ref$min = _ref.min,
    min = _ref$min === void 0 ? (0, _momentTimezone.default)().startOf('day') : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? (0, _momentTimezone.default)(min).add(1, 'year') : _ref$max,
    allDates = _ref.allDates,
    selectedDate = _ref.selectedDate,
    isAvailable = _ref.isAvailable,
    onChange = _ref.onChange;
  var allMonths = (0, _utils.getMonthsForRange)(min, max);
  var currentMonth = selectedDate ? selectedDate.month() : undefined;
  var handleMonthChange = function handleMonthChange(newMonth) {
    var newDate = allDates.find(function (date) {
      return date.month() === newMonth.month() && isAvailable(date);
    });
    onChange(newDate);
  };
  var hasPreviousMonth = currentMonth !== (0, _lodash.first)(allMonths);
  var handlePrevious = function handlePrevious() {
    return handleMonthChange((0, _momentTimezone.default)(selectedDate).subtract('month', 1));
  };
  var hasNextMonth = currentMonth !== (0, _lodash.last)(allMonths);
  var handleNext = function handleNext() {
    return handleMonthChange((0, _momentTimezone.default)(selectedDate).add('month', 1));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    icon: "caret-left-heavy-16",
    onClick: handlePrevious,
    disabled: !hasPreviousMonth,
    className: (0, _classnames.default)({
      invisible: !hasPreviousMonth
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-none text-center w-[86px] mx-[10px]"
  }, currentMonth !== undefined ? _momentTimezone.default.months(currentMonth) : 'N/A'), /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    icon: "caret-right-heavy-16",
    onClick: handleNext,
    disabled: !hasNextMonth,
    className: (0, _classnames.default)({
      invisible: !hasNextMonth
    })
  }));
};
var _default = MonthSelector;
exports.default = _default;